<div class="input-group">
  <!-- Prepend Text -->
  <span *ngIf="props.prependText"
        [ngClass]="props.prependTextClass">{{
    props.prependText
    }}</span>

  <!-- Prepend Button -->
  <button *ngIf="props.prependButtonText"
          type="button"
          [ngClass]="props.prependButtonClass"
          (click)="onPrependButtonClick()">
    {{ props.prependButtonText }}
  </button>

  <!-- Input Field -->
  <input *ngIf="type !== 'number'; else numberTmp"
         [type]="type"
         [formControl]="formControl"
         class="form-control"
         [ngClass]="props.class"
         [formlyAttributes]="field"
         [class.is-invalid]="showError" />
  <ng-template #numberTmp>
    <input type="number"
           [formControl]="formControl"
           class="form-control"
           [ngClass]="props.class"
           [formlyAttributes]="field"
           [class.is-invalid]="showError" />
  </ng-template>

  <!-- Append Text -->
  <span *ngIf="props.appendText"
        [ngClass]="props.appendTextClass">{{
    props.appendText
    }}</span>

  <!-- Append Button -->
  <button *ngIf="props.appendButtonText"
          type="button"
          [ngClass]="props.appendButtonClass"
          (click)="onAppendButtonClick()">
    {{ props.appendButtonText }}
  </button>
</div>